/**
 * <AddComponent 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import "./AddComponent.scss";
import Form from 'components/Form';
import locale from './locale';

class AddComponent extends React.Component {
  constructor(props) {
    super(props);

    this.addToPage = this.addToPage.bind(this);
  }

  componentWillMount() {

  }

  addToPage(item) {
    return ()=>{
      this.props.onSubmit(item);
    }
  }
  
  render() {
    const {
      isEdit,
      onCloseEditor,
      componentFormSchemas = {},
    } = this.props;

    return (
      <div className={classnames('AddComponent', { isEdit })}>
        <div className='AddComponent--content' ref={(r)=>{ 
          this.scrollingContainerRef = r;
        }}>
          <div className='ComponentEditor--formWrapper'>
            <ul>
              {Object.keys(componentFormSchemas).map((name, index)=>{
                const item = componentFormSchemas[name];
                return <li key={index}>{item.label} <i className='fa icon-plus add-to-page' onClick={this.addToPage(item)}></i></li>
              })}
            </ul>
            <button onClick={onCloseEditor} className='btn btn-default'>{__('Cancel', locale)}</button>
          </div>
        </div>
      </div>
    )
  }
}

export default AddComponent;



// WEBPACK FOOTER //
// ./src/containers/pages/Website/AddComponent/index.js